export function unwrapApiResult(result) {
  if (!result) {
    return null;
  }
  if (Array.isArray(result)) {
    return result;
  }
  const body = result.data?.result ?? result.result ?? result.data ?? result;
  if (body && !Array.isArray(body) && body.data != null) {
    return body.data;
  }
  return body;
}
